import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f4f5f9;
  background-image: url('/background.png');
  background-size: 100% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
`

const Logo = styled.img`
  display: block;
  width: 400px;
  height: auto;
`

const HomePage = () => {
  return (
    <Container>
      <Logo src='/logo.png' />
    </Container>
  )
}



export default HomePage
